import React, { FC, memo, useContext, useMemo } from "react";
import { useSelector } from "react-redux";

import { FeatureCardContext } from "../FeatureCardHeader/FeatureCardContext";
import { FeatureAttributes } from "./FeatureAttributes";
import { getProjectPage } from "../../../../ducks/project/selectors";
import { getContainerTemplate } from "../../utils/getContainerTemplate";
import { renderElement } from "../../utils/renderElement";
import { ContainerTemplate } from "../../types";

export const FeatureConfigAttributes: FC = memo(() => {
  const { layerInfo, attributes, selectedTabId, expandedContainers, setSelectedTabId, setHandBookReference } =
    useContext(FeatureCardContext);
  const page = useSelector(getProjectPage);
  const config = layerInfo.configuration.cardConfiguration;

  const render = useMemo(
    () => renderElement({ config, attributes, layerInfo, expandedContainers, selectedTabId, setSelectedTabId, page }),
    [config, attributes, layerInfo, expandedContainers, selectedTabId, setSelectedTabId, page],
  );

  if (!config) {
    return <FeatureAttributes layer={layerInfo} attributes={attributes} setHandBookReference={setHandBookReference} />;
  }

  const Container = getContainerTemplate(config.templateName || ContainerTemplate.ContainersGroup);

  return <Container config={config} attributes={attributes} layerInfo={layerInfo} renderElement={render} />;
});
